import React from 'react';
import { useState,  } from "react";
import classes from "./ProductDescImages.module.css";
import dylan from "../Allproducts/dylan.jpg";
import eros from "../Allproducts/eros.jpg";
import jpg from "../Allproducts/jpg.jpg";
import Spinner from 'react-bootstrap/Spinner';


function ProductDescImages(props){
    const [pic, setPic] = useState(props.product.data.images[0]);

   function changePic(newPic){
        setPic(newPic);

    }




    return(
        <div className={classes.vertical}>
             <div className={classes.div1}>
                <img className={classes.bigImage} src={pic}/>
            </div>
            <div className={classes.horizontal}>

                {props.product.data.images.map((image)=>(
                    <button className={classes.iconButton}><img  className={classes.smallImages}  onClick={()=>changePic(image)} src={image}/></button>
                ))}
               
            </div>
        </div>
    )
}

export default ProductDescImages;